export default __webpack_public_path__ + "static/media/empty-posts.05d09642.svg";